import { render, staticRenderFns } from "./FruehereTumorerkrankung.vue?vue&type=template&id=a313f3b2&"
import script from "./FruehereTumorerkrankung.vue?vue&type=script&lang=js&"
export * from "./FruehereTumorerkrankung.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VDivider,VListItem,VListItemContent,VSelect})
